import Vue from 'vue'

import AccountRepositoryMock from '@/repositories/AccountRepositoryMock'
import AnnouncementRepository from '@/repositories/AnnouncementRepository'
import MenuRepository from '@/repositories/MenuRepository'
import UploadFileRepository from '@/repositories/UploadFileRepository'
import TanaPowerExcelRepository from '@/repositories/TanaPowerExcelRepository'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.repositories) this.$repositories = options.repositories
    else if (options.parent && options.parent.$repositories)
      this.$repositories = options.parent.$repositories
  },
})

const tmpTapirApiRepositories = {
  uploadFile: UploadFileRepository,
  tanaPowerExcel: TanaPowerExcelRepository,
}

const mockMasterRepositories = {
  account: AccountRepositoryMock,
}

const giggleRepositories = {
  announcement: AnnouncementRepository,
  menu: MenuRepository,
}

export default {
  get(name) {
    let repository

    if (process.env.VUE_APP_TMP_TAPIR_API_URL_BASE) {
      repository = tmpTapirApiRepositories[name]
    } else {
      repository = tmpTapirApiRepositories[name]
    }

    if (repository) {
      return repository
    }

    if (process.env.VUE_APP_MASTER_API_URL_BASE) {
      repository = mockMasterRepositories[name]
    } else {
      repository = mockMasterRepositories[name]
    }

    if (repository) {
      return repository
    }

    if (process.env.VUE_APP_QUERY_API_URL_BASE) {
      repository = giggleRepositories[name]
    } else {
      repository = giggleRepositories[name]
    }

    if (repository) {
      return repository
    }

    throw new Error(`リポジトリ ${name} が見つかりませんでした`)
  },
}
